import Cookies from 'js-cookie'
import { getPartnerBySlug } from '@/config/partners'
import { PARTNER_COOKIE_NAME } from '@/lib/partner/routing'

export const readPartnerSource = (): string | undefined => {
  const slug = Cookies.get(PARTNER_COOKIE_NAME)
  if (!slug) return undefined
  return getPartnerBySlug(slug) ? slug : undefined
}
